import React from "react";
import { Switch, Route } from "react-router-dom";
import Slider from '../SwithSlider/SwitchSlider';

class SlideOut extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      childPosition: Slider.CENTER,
      curChild: props.children,
      curUniqId: props.uniqId,
      prevChild: null,
      prevUniqId: null,
      animationCallback: null
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const prevUniqId = prevProps.uniqKey || prevProps.children.type;
    const uniqId = this.props.uniqKey || this.props.children.type;
    if (prevUniqId !== uniqId) {
      let sliderPosition = null;
      if ((prevUniqId === '/reviews/addons' && uniqId === '/reviews/pay') || (prevUniqId === '/reviews/details' && uniqId === '/reviews/addons') ) {
        sliderPosition = Slider.TO_LEFT;
      } else if ((prevUniqId === '/reviews/pay' && uniqId === '/reviews/addons') || (prevUniqId === '/reviews/addons' && uniqId === '/reviews/details')) {
        sliderPosition = Slider.TO_RIGHT;
      }
      this.setState({
        childPosition: sliderPosition,
        curChild: this.props.children,
        curUniqId: uniqId,
        prevChild: prevProps.children,
        prevUniqId: prevUniqId,
        animationCallback: () => this.swapChildren(prevUniqId, uniqId)
      });
    }
  }

  swapChildren = (prevUniqId, uniqId) => {
    let sliderPosition = null;
    if ((prevUniqId === '/reviews/addons' && uniqId === '/reviews/pay') || (prevUniqId === '/reviews/details' && uniqId === '/reviews/addons') ) {
      sliderPosition = Slider.FROM_RIGHT;
    } else if ((prevUniqId === '/reviews/pay' && uniqId === '/reviews/addons') || (prevUniqId === '/reviews/addons' && uniqId === '/reviews/details')) {
      sliderPosition = Slider.FROM_LEFT;
    }
    this.setState({
      childPosition: sliderPosition,
      prevChild: null,
      prevUniqId: null,
      animationCallback: null
    });
  };

  render() {
    return (
      <Slider
        position={this.state.childPosition}
        animationCallback={this.state.animationCallback}
      >
        {this.state.prevChild || this.state.curChild}
      </Slider>
    );
  }
}

const animateSwitch = (CustomSwitch, AnimatorComponent) => ({
  updateStep,
  children
}) => (
  <Route
    render={({ location }) => (
      <AnimatorComponent uniqKey={location.pathname} updateStep={updateStep}>
        <CustomSwitch location={location}>{children}</CustomSwitch>
      </AnimatorComponent>
    )}
  />
);

const SwitchWithSlide = animateSwitch(Switch, SlideOut);

export default SwitchWithSlide;



// WEBPACK FOOTER //
// ./src/containers/SwitchWithSlide/SwitchWithSlide.js